import $ from 'jquery';


class Search{
    // 1. Describe and create/initiate our object. Selects particular element
    constructor(){
        // HTML search box initialized --- neds to be first otherwise other objects will not work
        this.addSearchHTML();

        this.resultsDiv = $("#search-overlay__results");
        this.openButton = $(".js-search-trigger");
        this.closeButton = $(".search-overlay__close");
        this.searchOverlay = $(".search-overlay");
        this.searchField = $("#search-term");

        // Initilize
        this.events();

        this.isOverlayOpen = false;

        // Spinner set up
        this.isSpinnerVisible = false;

        this.previousValue;

        // Set typing timer
        this.typingTimer;
    }

    // 2. Events
    events(){
        // Click events for opening - closing button
        // Refers to current instance of the Seach class by using .bind(this) to prevent undefined
        this.openButton.on("click",  this.openOverlay.bind(this));
        this.closeButton.on("click", this.closeOverlay.bind(this));

        // Refers to current instance of the Seach class by using .bind(this) to prevent undefined
        //  $(document) refers to DOM
        $(document).on("keydown", this.keyPressDispatcher.bind(this));


        // When the search field is open then run method when key is pressed
        this.searchField.on("keyup", this.typingLogic.bind(this));

    }

    // 3. Methods (function, action...). Describes events

    // Set timeout delay for better search experience
    typingLogic(){

    // by this below field check previous value to prevent auto spinner loader 
    if(this.searchField.val() != this.previousValue){
        // When every time we press a key that resets the timer
        // Refers to current instance of the Seach class by using .bind(this) to prevent undefined
       clearTimeout(this.typingTimer);


    //    check if the search field has any value
       if(this.searchField.val()){

          //   Prevent spinner autoload multiple times when typing
            if(!this.isSpinnerVisible){
                // set the loader   
                this.resultsDiv.html('<div class="spinner-loader"></div>');
                this.isSpinnerVisible = true;
            }
       } else{

        // Clear the div field for search result
        this.resultsDiv.html('');
        this.isSpinnerVisible = false;
       }

     
           
   
          this.typingTimer = setTimeout(this.getResults.bind(this), 750);
        }

    //  Run this method after every key press to prevent auto spinner loader 
        this.previousValue = this.searchField.val();
    }

    getResults(){

        // include data custom parameter to receive included data --->${results.generalInfo.length // generalInfo is in functions.php 
        // CUSTOM JSON modifications in functions.php

        // .map in that context is used to loop through each array Where each array item will be modified later on
        // Ternary operator used 
        //  ${item.type == 'post' ? ` by ${item.authorName}` : ''} ---> Display author name only for posts NOT pages

        //generalInfo is specified in custom array at functions.php
        $.getJSON(universityData.root_url + '/wp-json/university/v1/search?term=' + this.searchField.val(), results => {
            this.resultsDiv.html(`
                <div class="row">
                        <div class="one-third">
                            <h2 class="search-overlay__section-title">General Information</h2>
                            ${results.generalInfo.length ? '<ul class="link-list min-list">' : '<p>No general information matches that search.</p>'}
                                ${results.generalInfo.map(item => `<li><a href="${item.permalink}">${item.title}</a>${item.postType == 'post' ? ` by ${item.authorName}` : ''}</li>`).join('')}
                            ${results.generalInfo.length ? '</ul>' : ''}
                        </div>
                        <div class="one-third">
                            <h2 class="search-overlay__section-title">Programs</h2>
                            ${results.programs.length ? '<ul class="link-list min-list">' : `<p>No programs matche that search. <a href="${universityData.root_url}/programs">View all programs</a></p>`}
                                ${results.programs.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join('')}
                            ${results.programs.length ? '</ul>' : ''}

                            <h2 class="search-overlay__section-title">Professors</h2>
                            ${results.professors.length ? '<ul class="professor-cards">' : '<p>No professors matches that search.</p>'}
                                ${results.professors.map(item =>`
                                    <li class="professor-card__list-item">
                                        <a class="professor-card" href="${item.permalink}">

                                       
                                       
                                            <img class="professor-card__image" src="${item.image}" alt="">
                                            <span class="professor-card__name">${item.title}</span>
                                        </a>
                                    </li>
                                `).join('')}
                            ${results.professors.length ? '</ul>' : ''}
                        </div>
                        <div class="one-third">
                            <h2 class="search-overlay__section-title">Campuses</h2>
                            ${results.campuses.length ? '<ul class="link-list min-list">' : `<p>No campuses match that search.  <a href="${universityData.root_url}/campuses">View all campuses</a></p>`}
                                ${results.campuses.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join('')}
                            ${results.campuses.length ? '</ul>' : ''}
                            <h2 class="search-overlay__section-title">Events</h2>
                            ${results.events.length ? '' : `<p>No events match that search.  <a href="${universityData.root_url}/events">View all events</a></p>`}
                                ${results.events.map(item => `
                                        <div class="event-summary">
                                            <a class="event-summary__date t-center" href="${item.permalink}">
                                            <span class="event-summary__month">${item.month}</span>
                                            <span class="event-summary__day">${item.day}</span>
                                            </a>
                                        <div class="event-summary__content">
                                            <h5 class="event-summary__title headline headline--tiny"><a href="${item.permalink}">${item.title}</a></h5>
                                            
                                            <!-- Check if the post has filled excerpt field. If not then execute wp_trim_words() -->
                                            <!-- wp_trim_words(get content fron the post body, words amount) Clip the post content  -->
                                            <p>${item.description}<a href="${item.permalink}" class="nu gray">Learn more</a></p>
                                        </div>
                                    </div>
                                `).join('')}
                        </div>
                </div>
            `);
            this.isSpinnerVisible = false
        });

        
    }

// Key press events to open/close search box
    keyPressDispatcher(event){

        // If the key is pressed then run a opening method and If there is not opened overlay and check if any text fields are currently focused
        if(event.keyCode == 83 && !this.isOverlayOpen && !$("input, textarea").is(':focus')){
            this.openOverlay();
        }

        if(event.keyCode == 27 && this.isOverlayOpen){
            this.closeOverlay();
        }


    }


    openOverlay(){
        // Add class
        this.searchOverlay.addClass("search-overlay--active");

        // Prevent to scroll when seach window is opened
        $("body").addClass("body-no-scroll");
        console.log("our open method just ran!");

        // Empty seach txt field when search box is reopened again 
        this.searchField.val('');

        // Put the cursor in search text field when opened for all browsers
        setTimeout(() => this.searchField.focus(), 301);
        

        // Run method only once
        this.isOverlayOpen = true;

        // Do not open pop up window when JS is disabled in certain browsers
        return false;
    }


    closeOverlay(){
        // Remove class
        this.searchOverlay.removeClass("search-overlay--active");

        // Reenble scroll when seach window is closed
        $("body").removeClass("body-no-scroll");

        console.log("our close method just ran!");

        // Run method only once
        this.isOverlayOpen = false;
    }

// Run HTML Search box
    addSearchHTML(){
        $("body").append(`
                <div class="search-overlay">
                <div class="seach-overlay__top">
                <div class="container">
                    <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
            
                    <!-- autocomplete="off" prevents any auto suggestions for certain browsers -->
                    <input type="text" class="search-term" placeholder="What are you looking for?" id="search-term" autocomplete="off">
                    <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
                </div>
                </div>
            
                <div class="container">
                <div id="search-overlay__results"></div>
                </div>
            </div>
        `)
    }

}


// Import this file to main script WP file
export default Search